// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"2442":"1c33771a7eb36099","6350":"592d51273e801770","7856":"d14c943ea36d9756"}[chunkId] + ".js";
};